import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Link } from "react-router";

function DialogContact({ email }: { email: string }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="cursor-pointer">Contacts</div>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] z-[100000]">
        <DialogHeader>
          <DialogTitle>Email</DialogTitle>
          <DialogDescription>
            Feel free to reach out to us for any questions at:{" "}
            <span className="font-semibold">{email}</span>
            <div className="mt-4">
              You can join our community at:{" "}
              <Link to="https://discord.gg/eafSXxrB3F" target="_blank">
                https://discord.gg/eafSXxrB3F
              </Link>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export default DialogContact;
